export enum SecurityListViewInOption {
    VIEW_IN_STOCK_SCREENER = 'view_in_stock_screener',
    VIEW_IN_FUND_SCREENER = 'view_in_fund_screener',
    VIEW_IN_COMP_TABLES = 'view_in_comp_tables',
    VIEW_IN_TIMESERIES = 'view_in_timeseries',
    VIEW_IN_NEWS = 'view_in_news',
    VIEW_IN_TECH_CHART = 'view_in_technical_chart',
    VIEW_IN_FUND_CHART = 'view_in_fund_chart',
    VIEW_IN_SCATTER_PLOT = 'view_in_scatter_plot',
    VIEW_IN_MODEL_PORTFOLIO = 'view_in_model_portfolio',
}

export enum IndicatorListViewInOption {
    VIEW_IN_TIMESERIES = 'view_in_timeseries',
    VIEW_IN_FUND_CHART = 'view_in_fund_chart',
}
